import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/VideoPlayerWithSRT',
    name: 'VideoPlayerWithSRT',
    component: () => import('@/views/VideoPlayerWithSRT')
  },
  {
    path: '/0120328/play/:unit?/:lesson?',
    redirect: to => {
      const { unit, lesson } = to.params;
      return `/book/0120328${unit ? `/${unit}` : ''}${lesson ? `/${lesson}` : ''}`
    },
    meta: { requiresAuth: false }
  },
  {
    path: '/basic-grammar/play/:unit/:lesson',
    redirect: to => {
      const { unit, lesson } = to.params;
      return `/book/1100204/${unit}/${lesson}`;
    },
    meta: { requiresAuth: false }
  },
  {
    path: '/ebook/:product_no/play/:unit?/:lesson?',
    redirect: to => {
      const { product_no, unit, lesson } = to.params;
      return `/book/${product_no}${unit ? `/${unit}` : ''}${lesson ? `/${lesson}` : ''}`;
    },
    meta: { requiresAuth: false }
  },
  {
    path: '/book/:product_no/play/:unit?/:lesson?',
    redirect: to => {
      const { product_no, unit, lesson } = to.params;
      return `/book/${product_no}${unit ? `/${unit}` : ''}${lesson ? `/${lesson}` : ''}`;
    },
    meta: { requiresAuth: false }
  },
  {
    path: '/magzine/:book/:id?/:section?/:parts?',
    redirect: to => {
      const { book, id, section, parts } = to.params;
      return `/magazine/${book}` +
        (id ? `/${id}` : '') +
        (section ? `/${section}` : '') +
        (parts ? `/${parts}` : '');
    },
    meta: { requiresAuth: false }
  },
  {
    path: '/book/:product_no/:unit?/:lesson?',
    name: 'Book',
    component: () => import('@/views/NewBook'),
    meta: { requiresAuth: false }
  },
  {
    path: '/magazine/:book/:id?/:section?/:parts?',
    name: 'magazine',
    component: () => import('@/views/Magazine'),
    meta: { requiresAuth: false }
  },
  {
    path: '/adminlogin',
    name: 'adminlogin',
    component: () => import('@/views/LoginSection'),
    meta: { requiresAuth: false }
  },
  {
    path: '/management',
    name: 'manage',
    component: () => import('@/views/backstage/Layout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/backstage/ListSection'),
        meta: { requiresAuth: true }
      },
      {
        path: 'edit/:book?',
        name: 'edit',
        component: () => import('@/views/backstage/EditSection'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/NoWorkingPage')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('qrCodeToken')

  if (to.meta.requiresAuth && !token) {
    next({ name: 'adminlogin' })
  } else {
    next()
  }
})

export default router
